<template>
  <div>

    <div class="grid-x grid-padding-y">
      <div class="large-12 cell">
        <p class="text-center">&nbsp;</p>
      </div>
    </div>
    <div class="grid-container container first">
      <div class="grid-x grid-padding-x layout">
        <div class="cell medium-6 large-4 large-centered">
          <form ref="f" class="" data-abide novalidate>
            <div class="card-section">
              <div class="text-center h4">
                <router-link to="login" style="color: inherit;">
                  Sign In
                </router-link>
                <span>/</span>
                <router-link to="" style="color: inherit;">
                  Register
                </router-link>
              </div>
              <div class="padding-top-1 padding-bottom-1">
<p style="font-size: 1rem;">
                  Create an account with OneBuy to select your enquiries
                  anytime.
                </p>
              </div>

              <label>
                <input
                  name="FirstName"
                  type="text"
                  placeholder="Fist Name"
                  v-model="model.FirstName"
                  autofocus
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>
              <label>
                <input
                  name="LastName"
                  type="text"
                  placeholder="Last Name"
                  v-model="model.LastName"
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>

              <label>
                <input
                  name="UserName"
                  type="email"
                  placeholder="Email"
                  v-model="model.UserName"
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>
              <label>
                <input
                  name="PhoneNumber"
                  type="text"
                  placeholder="Phone Number"
                  v-model="model.PhoneNumber"
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>
              <label>
                <input
                  name="Country"
                  type="text"
                  placeholder="Country"
                  v-model="model.Country"
                  required
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>

              <p style="clear: both;">&nbsp;</p>
              <p>
                <input
                  id="register"
                  name="register"
                  type="submit"
                  class="button expanded radius large"
                  value="Register"
                />
              </p>

              <div v-show="errored" class="alert callout">
                <p>
                  This email was already registered. <br />
                  <router-link :to="{name:'forgotPassword', params:{email: model.UserName}}">Forgot your password?</router-link>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="container"></div>
  </div>
</template>

<script>
import AccountRepository from "@/app.account/services/main-service.js";

export default {
  name: "appRegister",
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      model: {},
      isValid: false,
      loading: false,
      errored: false,
    };
  },
  mounted() {
    let _this = this;

    $(this.$refs.f)
      .on("invalid.zf.abide", function() {
        _this.isValid = false;
      })
      .on("formvalid.zf.abide", function() {
        _this.isValid = true;
      })
      .on("submit", function(ev) {
        ev.preventDefault();

        if (_this.isValid) {
          _this.onSubmit();
        } else {
          // console.log("error");
        }
      });
  },
  methods: {
    async onSubmit() {
      this.$refs.f.register.disabled = true;

      try {
        const { data } = await AccountRepository.register(this.model);
        if (data.succeeded) {
          this.$router.push({
            name: "registerSent",
            params: {
              email: this.model.UserName,
            },
          });
        } else {
          this.errored = true;
        }
      } catch (error) {
        this.errored = true;
        console.error(error);
      } finally {
        this.loading = this.$refs.f.register.disabled = false;
      }

      if (this.errored) {
        setTimeout(() => (this.errored = false), 9000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 1.5rem;
  .large-centered {
    margin: 0 auto;
  }
}

.banner-description {
  background-image: linear-gradient(to bottom right, #cec9c9, white);
}

.router-link-exact-active {
  text-decoration: underline;
}
</style>
